export const diagnosticos = {

    "Trastornos mentales orgánicos, incluyendo los sintomáticos": {
        F00: "Demencia en la enfermedad de Alzheimer",
        F01: "Demencia vascular",
        F02: "Demencia en enfermedades clasificadas en otro lugar",
        F03: "Demencia sin especificación",
        F04: "Síndrome amnésico orgánico no inducido por alcohol u otras sustancias psicótropas",
        F05: "Delirium no inducido por alcohol u otras sustancias psicótropas",
        F06: "Otros trastornos mentales debidos a lesión o disfunción cerebral o enfermedad somática",
        F07: "Trastornos de la personalidad y del comportamiento debidos a enfermedad, lesión o disfunción cerebral",
        F09: "Trastorno mental orgánico o sintomático sin especificación"
    },

    "Trastornos mentales y del comportamiento debidos al consumo de sustancias psicótropas": {
        "F10": "Trastornos mentales y del comportamiento debidos al consumo de alcohol",
        "F11": "Trastornos mentales y del comportamiento debidos al consumo de opioides ",
        "F12": "Trastornos mentales y del comportamiento debidos al consumo de cannabinoides ",
        "F13": "Trastornos mentales y del comportamiento debidos al consumo de sedantes o hipnóticos",
        "F14": "Trastornos mentales y del comportamiento debidos al consumo de cocaína",
        "F15": "Trastornos mentales y del comportamiento debidos al consumo de otros estimulantes (incluida cafeína)",
        "F16": "Trastornos mentales y del comportamiento debidos al consumo de alucinógenos",
        "F17": "Trastornos mentales y del comportamiento debidos al consumo de tabaco",
        "F18": "Trastornos mentales y del comportamiento debidos al consumo de disolventes volátiles",
        "F19": "Trastornos mentales y del comportamiento debidos al consumo de múltiples drogas o de otras sustancias psicotrópicas"
    },
    "Esquizofrenia, trastorno esquizotípico y trastorno de ideas delirantes": {
        "F20": "Esquizofrenia",
        "F21": "Trastorno esquizotípico",
        "F22": "Trastorno de ideas delirantes persistentes",
        "F23": "Trastornos psicóticos agudos y transitorios",
        "F24": "Trastorno de ideas delirantes inducidas",
        "F25": "Trastornos esquizoafectivos",
        "F28": "Otros trastornos psicóticos no orgánicos ",
        "F29": "Psicosis no orgánica sin especificación"
    },
    "F40-F48 Trastornos neuróticos, secundarios a situaciones estresantes y somatomorfos": {
        F40: "Trastorno de ansiedad fóbica",
        "F40.0": "Agorafobia",
        "F40.1": "Fobias sociales",
        "F40.2": "Fobias específicas",
        F41: "Otros trastornos de ansiedad",
        "F41.0": "Trastorno de pánico",
        "F41.1": "Trastorno de ansiedad generalizada",
        "F41.2": "Trastorno mixto ansioso-depresivo",
        F42: "Trastorno obsesivo-compulsivo",
        F43: "Reacción a estrés agudo",
        "F43.1": "Trastornos estrés postraumático",
        "F43.2": "Trastornos de adaptación",
        "F43.8": "Otras reacciones a estrés grave",
        "F43.9": "Reacción a estrés grave sin especificación",
        "F44": "Trastornos disociativos (de conversión",
        F45: "Trastornos somatomorfos",
        F48: "Otros trastornos neuróticos"
    },
    "F50-F59 Trastornos del comportamiento asociados a disfunciones fisiológicas y a factores somáticos": {
        F50: "Trastornos de la conducta alimentaria ",
        "F50.0": "Anorexia nerviosa",
        "F50.1": "Anorexia nerviosa atípica",
        "F50.2": "Bulimia nerviosa",
        "F50.3": "Bulimia nerviosa atípica",
        F51: "Trastornos no orgánicos del sueño",
        "F51.0": "Insomnio no orgánico",
        "F51.1": "Hipersomnia no orgánica",
        "F51.2": "Trastorno no orgánico del ciclo sueño-vigilia",
        "F51.3": "Sonambulismo",
        "F51.4": "Terrores nocturnos",
        "F51.5": "Pesadillas ",
        F52: "Disfunción sexual no orgánica",
        F53: "Trastornos mentales y del comportamiento en el puerperio no clasificadas en otro lugar",
        F54: " Factores psicológicos y del comportamiento en trastornos o enfermedades clasificadas en otro lugar",
        F55: "Abuso de sustancias que no producen dependencia",
        F59: "Trastornos del comportamiento asociados a disfunciones fisiológicas y a factores somáticos sin especificación"
    },
    "F60-F69 Trastornos de la personalidad y del comportamiento del adulto": {
        F60: "Trastornos específicos de la personalidad",
        "F60.0": "Trastorno paranoide de la personalidad",
        "F60.1": "Trastorno esquizoide de la personalidad",
        "F60.2": "Trastorno disocial de la personalidad",
        "F60.3": "Trastorno de inestabilidad emocional de la personalidad",
        "F60.4": "Trastorno histriónico de la personalidad",
        "F60.5": "Trastorno anancástico de la personalidad",
        "F60.6": "Trastorno ansioso de la personalidad",
        "F60.7": "Trastorno dependiente de la personalidad",
        "F60.8": "Otros trastornos específicos de la personalidad",
        "F60.9": "Trastornos de la personalidad sin especificación "
    },
    "F61 Trastornos mixtos y otros trastornos de la personalidad": {
        "F61.0": "Trastornos mixtos de la personalidad"
    },

    "F62 Transformación persistente de la personalidad no atribuible a lesión o enfermedad cerebral ": {
        "F62.0": "Transformación persistente de la personalidad no atribuible a lesión o enfermedad cerebral "
    },

    "F63 Trastorno de los hábitos y del control de los impulsos": {
        "F63.0": "Trastorno de los hábitos y del control de los impulsos"
    },

    "F64 Trastorno de identidad sexual": {
        "F64.0": "Trastorno de identidad sexual"
    },

    "F65 Trastornos de inclinación sexual": {
        "F65.0": "Trastornos de inclinación sexual"
    },
    "F66 Trastornos psicológicos y del comportamiento del desarrollo y orientación sexuales": {
        "F66.0": "Trastornos psicológicos y del comportamiento del desarrollo y orientación sexuales"
    },

    "F68 Otros trastornos de la personalidad y del comportamiento del adulto ": {
        "F68.0": "Otros trastornos de la personalidad y del comportamiento del adulto "
    },

    "F69 Trastorno de la personalidad y del comportamiento del adulto sin especificación": {
        "F69.0": "Trastorno de la personalidad y del comportamiento del adulto sin especificación"
    },
    "F70-F79 Retraso mental": {
        F70: "Retraso mental leve",
        F71: "Retraso mental moderado ",
        F72: "Retraso mental grave ",
        F73: "Retraso mental profundo ",
        F78: "Otro retraso mental ",
        F79: "Retraso mental sin especificación "
    },
    "F80-F89 trastornos del desarrollo psicológico": {
        F80: "Trastornos específicos del desarrollo del habla y de lenguaje",
        F81: "Trastornos específicos del desarrollo del aprendizaje escolar",
        F82: "Trastorno específico del desarrollo psicomotor",
        F83: "Trastorno específico del desarrollo mixto",
        F84: "Trastornos generalizados del desarrollo",
        F88: "Otros trastornos del desarrollo psicológico",
        F89: "Trastorno del desarrollo psicológico sin especificación"
    },

    "F90-F98 Trastornos del comportamiento y de las emociones de comienzo habitual en la infancia y adolescencia ": {
        F90: "Trastornos hipercinéticos ",
        F91: "Trastornos disociales ",
        F92: "Trastornos disociales y de las emociones mixtos ",
        F93: "Trastornos de las emociones de comienzo habitual en la infancia ",
        F94: "Trastornos del comportamiento social de comienzo habitual en la infancia y adolescencia ",
        F95: " Trastornos de tics",
        F98: "Otros trastornos de las emociones y del comportamiento de comienzo habitual en la infancia y adolescencia ",
        F99: "Trastorno mental sin especificación"
    },
    "H93-H95 Trastornos del oído y de la apófisis mastoides": { 
        "H93": "Trastornos del oído y de la apófisis mastoides",
        "H93.0": "Trastornos del oído interno",
        "H93.1": "Trastornos del oído medio",
        "H93.2": "Trastornos del oído externo",
        "H93.3": "Trastornos de la apófisis mastoides",
        "H93.8": "Otros trastornos del oído y de la apófisis mastoides",
        "H93.9": "Trastorno del oído y de la apófisis mastoides sin especificación",
        "H93.10": "Tinnitus oido no especificado",
        "H93.11": "Tinnitus oido derecho",
        "H93.12": "Tinnitus oido izquierdo",
        "H93.13": "Tinnitus oidos bilateral",
        "H93.19": "Tinnitus oidos no especificados",
        "H93.A1": "Tinnitus pulsatil, oido derecho",
        "H93.A2": "Tinnitus pulsatil, oido izquierdo",
        "H93.A3": "Tinnitus pulsatil, oidos bilateral",
        "H93.A9": "Tinnitus pulsatil, oidos no especificados",
        "H93.21": "Cambio temporal de umbral auditivo o hipersensibilidad al sonido",
        "H93.23": "Hipersensibilidad al sonido",
        "H93.29": "Otras (incluye diplacusia, hiperacusia, fonofobia, misofonia)",
        
    },
    "X60-X84 Autolesiones intencionales": {
        X60: "Envenenamiento intencionalmente autoinfligido por analgésicos no opiáceos, antipiréticos o antirreumáticos ",
        X61: "Envenenamiento intencionalmente autoinfligido por fármacos antiepilépticos, sedantes, hipnóticos, antiparkinsonianos y psicotrópicos no clasificados en otro lugar",
        X62: "Envenenamiento Intencional autoinfligido por narcóticosy psicodisléptlcos (alucinógenos) no clasificados en otro lugar",
        X63: "	Envenenamiento Intencionalmente autoinfligido por otrosfármacos que actúan sobre el sistema nervioso autónomo",
        X64: "Envenenamiento Intencionalmente autoinfligido por otras drogas, fármacos o productos biológicos",
        X65: "Envenenamiento Intencionalmente autoinfligido por alcohol",
        X66: "Envenenamiento Intencionalmente autoinfligido por solventes orgánicos, hidrocarburos halogenados o a sus vapores",
        X67: "Envenenamiento Intencionalmente autoinfligido por exposición a otros gases y vapores",
        X68: "Envenenamiento Intencionalmente autoinfligido por pesticidas",
        X69: "	Envenenamiento Intencionalmente autoinfligido por otras sustancias químicas o nocivas no especificadas",
        X70: "Daño intencionalmente autoinfligido por ahorcamiento, estrangulación o sofocación",
        X71: "Daño intencionalmente autoinfligido por ahogamiento e inmersión",
        X72: "Daño intencionalmente autoinfligido por disparo de arma corta",
        X73: "Daño intencionalmente autoinfligido por disparo de rifles, escopetas o arma larga",
        X74: "Daño intencionalmente autoinfligido por otras armas de fuego",
        X75: "Daño intencionalmente autoinfligido por material explosivo",
        X76: "Daño intencionalmente autoinfligido por fuego y llamas",
        X77: "Daño intencionalmente autoinfligido por vapor de agua, vapores u objetos calientes",
        X78: "Daño intencionalmente autoinfligido por un objeto cortante",
        X79: "Daño intencionalmente autoinfligido por objetos romos",
        X80: "Daño intencionalmente autoinfligido porsalto desde un lugar elevado",
        X81: "Daño intencionalmente autoinfligido por arrojarse o tenderse ante un objeto en movimiento",
        X82: "Daño intencionalmente autoinfligido por choque con vehículo de motor  ",
        X83: "Daño intencionalmente autoinfligido por otros medios específicos",
        X84: "Daño intencionalmente autoinfligido por medios inespecíficos"
    },
    "Y06 Negligencia y abandono": { "Y06.0": "Negligencia y abandono" },
    "Y07 Otros síndromes de malos tratos": { "Y07.0": "Otros síndromes de malos tratos" },
    "Y40-Y59 Drogas, medicamentos y sustancias biológicas que causan efectos adversos en uso terapéutico": {
        Y46: "Antiepilépticos y antiparkinsonianos",
        Y47: "Sedantes, hipnóticos y ansiolíticos",
        Y49: "Psicótropos no clasificados en otro lugar ",
        Y50: "Estimulantes del sistema nervioso central no clasificados en otro lugar",
        Y51: "Fármacos que afectan primariamente al sistema nervioso autónomo ",
        Y57: "Otros fármacos y drogas sin especificar"
    },
    "Z00-Z99 Factores que influyen en el estado de salud y en el contacto con los servicios de salud": {
        "Z55": "Problemas relacionados con la educación y la alfabetización",
        "Z56": "Problemas relacionados con el empleo y desempleo",
        "Z59": "Problemas relacionados con la vivienda y las condiciones económicas",
        "Z60": "	Problemas relacionados con el ambiente social",
        "Z60.0": "Problemas de ajuste a las transiciones de los ciclos vitales",
        "Z60.1": "Situaciones familiares atípicas",
        "Z60.2": "Vivir solo",
        "Z60.3": "Dificultades en la adaptación cultural",
        "Z60.4": "Exclusión y rechazo social",
        "Z60.5": "Ser blanco de discriminación adversa y persecución ",
        "Z61.0": "Pérdida de relaciones afectivas en la infancia",
        "Z61.1": "Cambio de domicilio en la niñez",
        "Z61.2": "Patrones de relaciones familiares alterados en la infancia",
        "Z61.3": "Hechos contundentes a la pérdida de la autoestima en la niñez",
        "Z61.4": "Problemas relacionados con presunto abuso sexual del niño por una persona dentro del grupo de apoyo primario",
        "Z61.5": "Problemas relacionados con presunto abuso sexual del niño por una persona no perteneciente al grupo de apoyo primario",
        "Z61.6": " Problemas relacionados con presunto abuso físico del niño",
        "Z61.7": "Experiencias personales atemorizantes en la niñez",
        "Z62.0": "	Supervisión y control inadecuados por parte de los padres",
        "Z62.1": "Sobreprotección parental",
        "Z62.2": "Crianza en una institución",
        "Z62.3": "Hostigamiento y acusación de culpabilidad al niño",
        "Z62.4": "Abandono emocional del niño",
        "Z62.5": "	Otros problemas relacionados con la negligencia en la crianza del niño",
        "Z62.6": "Presiones inapropiadas de los padres y otras anormalidades en la crianza",
        "Z63.0": "Problemas en la relación entre esposos o pareja",
        "Z63.1": "Problemas en la relación con los padres y los familiares políticos",
        "Z63.2": "Problemas relacionados con el apoyo familiar inadecuado",
        "Z63.3": "Problemas relacionados con la ausencia de un miembro de la familia",
        "Z63.4": "Problemas relacionados con la desaparición o muerte de un miembro de la familia",
        "Z63.5": "Problemas relacionados con la ruptura familiar por separación o divorcio",
        "Z63.6": "Problemas relacionados con familiar dependiente, necesitado de cuidado en la casa",
        "Z63.7": "Problemas relacionados con otros hechos estresantes que afectan a la familia y al hogar",
        "Z64.0": "Problemas relacionados con embarazo no deseado",
        "Z64.1": "Problemas relacionados con la multiparidad",
        "Z64.2": "Problemas relacionados con la solicitud o aceptación de intervenciones físicas, nutricionales y químicas, conociendo su riesgo y peligro",
        "Z64.3": "Problemas relacionados con la solicitud o aceptación de intervenciones psicológicas o de la conducta, conociendo su riesgo y peligro",
        "Z64.4": "Problemas relacionados con el desacuerdo con consejeros",
        "Z65.0": "Problemas relacionados con culpabilidad en procedimientos civiles o criminales sin prisión",
        "Z65.1": "Problemas relacionados con prisión y otro encarcelamiento",
        "Z65.2": "Problemas relacionados con la liberación de la prisión",
        "Z65.3": "Problemas relacionados con otras circunstancias legales",
        "Z65.4": "Problemas relacionados con víctima de crimen o terrorismo",
        "Z65.5": "Problemas relacionados con la exposición a desastre, guerra u otras hostilidades",
        "Z86.4": "Historia personal de abuso de sustancias psicoactivas",
        "Z86.5": "Historia personal de otros trastornos mentales o del comportamiento",
        "Z91.1": "Historia personal de incumplimiento del régimen o tratamiento médico",
        "Z91.3": "Historia personal de ciclo sueño-vigilia no saludable",
        "Z91.4": "Historia personal de trauma psicológico, no clasificado en otra parte",
        "Z91.5": "HISTORIA PERSONAL DE LESIÓN AUTOINFLIGIDA INTENCIONALMENTE",
    }
}